// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"e6d04ad0","787":"dc34930a"}[chunkId] + ".chunk.js";
};